<template>
  <b-dropdown
    id="dropdown-dropleft"
    ref="dropdown"
    no-caret
    dropleft
    :size="buttonSize"
    :variant="buttonType"
    :class="containerClass"
    @hide="hideDropdownHandler"
    @show="showDropdownHandler"
  >
    <template #button-content>
      <slot name="button-content">
        <div
          v-if="!buttonText"
          class="text-secondary"
          style="transform: rotate(90deg)"
        >
          <fa-icon :icon="['fas', 'ellipsis']" />
        </div>
        <div v-else>
          {{ buttonText }}
        </div>
      </slot>
    </template>

    <h6
      class="text-center p-2 font-weight-bold"
      style="border-bottom: 2px solid #ddd"
    >
      {{ header }}
    </h6>

    <b-dropdown-text class="mt-3" style="width: 300px">
      <div>
        <b-form-checkbox-group
          v-model="selected"
          :options="options"
          class="mb-3 ml-5"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          stacked
          @change="changeHandler"
        ></b-form-checkbox-group>
        <b-container class="text-center mb-3 mt-4">
          <b-button
            :disabled="isCancelButtonDisabled"
            class="button-width p-1"
            variant="outline-primary"
            @click="cancelClickHandler"
            >Cancel</b-button
          >
          <b-button
            class="button-width p-1"
            variant="primary"
            @click="saveButtonClickHandler"
            >Save</b-button
          >
        </b-container>
      </div>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    containerClass: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      default: 'Customize your table view',
    },
    defaultState: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    tableName: {
      type: String,
      default: 'default',
    },
    selectedTableColumns: {
      type: Array,
      default: () => [],
    },
    buttonType: {
      type: String,
      default: 'link',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonSize: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      selected: [],
      isCancelButtonDisabled: true,
      defaultStateTest: [],
    };
  },
  mounted() {
    this.restoreToDefaultState();
    this.clearOldLocalStorage();
  },
  methods: {
    getColumnsFromLocalStorage() {
      const ls = JSON.parse(localStorage.getItem('tablesSettings')) || {
        columns: {},
      };

      return ls.columns ? ls.columns[this.tableName] : [];
    },

    restoreToDefaultState() {
      this.selected = this.getColumnsFromLocalStorage() || this.defaultState;
      this.updateState(this.selected);
    },

    restoreToPriorState() {
      this.selected =
        this.getColumnsFromLocalStorage() ||
        this.selectedTableColumns ||
        this.defaultState;
      this.updateState(this.selected);
    },

    changeHandler() {
      this.isCancelButtonDisabled = false;
    },

    hideDropdownHandler() {
      this.isCancelButtonDisabled = true;
      this.restoreToPriorState();
    },

    showDropdownHandler() {
      this.restoreToDefaultState();
    },

    cancelClickHandler() {
      this.selected = this.getColumnsFromLocalStorage() || this.defaultState;
      this.updateState(this.selected);
      this.$refs.dropdown.hide(true);
      this.isCancelButtonDisabled = true;
    },

    updateLocalStorage: function (patch) {
      const upd = JSON.parse(localStorage.getItem('tablesSettings')) || {
        columns: {},
      };

      if (!upd.columns) {
        upd.columns = {};
      }

      upd.columns[this.tableName] = patch;
      localStorage.setItem('tablesSettings', JSON.stringify(upd));
    },

    updateState(patch) {
      this.$emit('update:selectedTableColumns', patch);
    },

    saveButtonClickHandler() {
      this.isCancelButtonDisabled = true;
      this.updateState(this.selected);
      this.updateLocalStorage(this.selected);
      this.$refs.dropdown.hide(true);
    },

    clearOldLocalStorage() {
      if (localStorage.getItem('campaignTableColumns')) {
        localStorage.removeItem('campaignTableColumns');
      }
    },
  },
};
</script>

<style>
.custom-control {
  margin-bottom: 5px;
}
.button-width {
  min-width: 100px;
}
</style>
